export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_AD_UI_CLIENTID, // read from .env file
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AD_UI_TENANTID}`,
        redirectUri: process.env.REACT_APP_AD_LOGIN_REDIRECT, // read from .env file
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    }
};

export const loginRequest = {
    scopes: ["openid", "profile", "email", process.env.REACT_APP_AD_UI_SCOPE],
};
